// Generic, logic-free helpers shared by the seed builders (fillModeBuilders.js)
// and the per-slot overrides (slotOverrides.js). Seed-specific date math
// (targetExpiration, expirationOnDay, productionFor) deliberately stays in
// fillModeBuilders.js — only the plumbing lives here.

export const CST_TIMEZONE = 'America/Chicago';
export const MS_PER_DAY = 86400000;

export function uuidv4() {
  if (
    typeof crypto !== 'undefined' &&
    typeof crypto.randomUUID === 'function'
  ) {
    return crypto.randomUUID();
  }
  // RFC4122 v4 fallback (browsers without randomUUID).
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    // eslint-disable-next-line no-bitwise
    const r = (Math.random() * 16) | 0;
    // eslint-disable-next-line no-bitwise
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

// A Date whose local wall-clock matches Chicago time. Used as the anchor for
// the day-offset math in the seed builders.
export function cstNow() {
  const s = new Date().toLocaleString('en-US', { timeZone: CST_TIMEZONE });
  return new Date(s);
}

export function addDays(date, days) {
  return new Date(date.getTime() + days * MS_PER_DAY);
}
